import { useCallback, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import cn from 'clsx';
import Logo from '@images/cc.png';
import { ChevronLeftIcon, MenuIcon } from '@components/elements/Icons';
import SideMenu from './SideMenu';

import { adminGetDefaultConfiguration } from '@sdk/managers/AdminManager';
import useSwr from 'swr';
import { GraphQLResult } from '@aws-amplify/api';
import { getImageUrl } from '@utils/image';

const actionCn =
  'unstyled-btn cursor-pointer bg-red p-2 fill-current text-white rounded-lg duration-300 hover:bg-white hover:bg-opacity-5 active:text-cyan font-display font-semibold text-sm';

const Navbar: React.FC = () => {
  const history = useHistory<any>();
  const location = useLocation();
  const [menu, setMenu] = useState<boolean>(false);

  const { data } = useSwr<any>(
    ['/site'],
    async (_query: string) => {
      const res = (await adminGetDefaultConfiguration()) as GraphQLResult<{
        result: {
          items: any[];
        };
      }>;
      const config = res.data?.result.items?.[0];
      console.log('config', config);
      if (!config) return {};
      const payload = {
        ...config,
        logoSrc: config?.logo ? await getImageUrl(config.logo) : undefined,
        pollImageSrc: config?.pollImage
          ? await getImageUrl(config.pollImage)
          : undefined,
      };
      return payload;
    },
    {
      revalidateOnFocus: false,
      onError: (err, key) => {
        console.log('Failed to fetch site', { key }, err);
      },
    }
  );

  const { hasBack, hasButton } = useMemo(() => {
    const parts = location.pathname.split('/');
    const res = {
      hasBack: true,
      hasButton: false,
    };
    if (parts[1] === 'admin') res.hasBack = parts.length > 3;
    if (parts[1] === 'feed') res.hasBack = false;
    if (parts.length > 2) {
      if (parts[1] === 'poll' && parts[2] === 'create') {
        res.hasBack = false;
      }
      if (parts[2] === 'setup') {
        res.hasBack = false;
        res.hasButton = false;
      }
    }
    return res;
  }, [location]);

  const action = useMemo(() => {
    if (
      location.pathname.startsWith('/poll/') &&
      location.pathname.endsWith('/edit')
    ) {
      return {
        label: 'View Poll',
        onClick: () => history.push(location.pathname.replace('/edit', '')),
      };
    }
    return null;
  }, [location, history]);

  const goBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const goHome = useCallback(() => {
    history.push('/home');
  }, [history]);

  const hideMenu = useCallback(() => {
    setMenu(false);
  }, [setMenu]);

  const toggleMenu = useCallback(() => {
    setMenu(!menu);
  }, [setMenu, menu]);

  const rootCn = cn(
    'fixed top-0 w-full py-2 px-2 h-14 bg-gradient-to-b from-shadow-0 via-shadow-500 to-transparent',
    {
      'bg-white shadow-lg': false,
    }
  );

  return (
    <>
      <SideMenu open={menu} onClose={hideMenu} />
      <div className={rootCn} style={{ zIndex: 40 }}>
        <div className="container flex items-center justify-between mx-auto">
          <div className="w-1/4">
            {hasButton && (
              <>
                {hasBack ? (
                  <button className={actionCn} onClick={goBack}>
                    <ChevronLeftIcon />
                  </button>
                ) : (
                  <button className={actionCn} onClick={toggleMenu}>
                    <MenuIcon />
                  </button>
                )}
              </>
            )}
          </div>
          <div>
            <div
              role="button"
              className="text-xl font-bold text-white transition-colors font-display hover:text-magenta"
              onClick={goHome}
            >
              {/* Dont show mightpoll text if loading */}
              <img className="h-10 py-2" src={Logo} alt="MegaX World" />
            </div>
          </div>
          <div className="flex justify-end w-1/4">
            {action && (
              <div role="button" className={actionCn} onClick={action.onClick}>
                {action.label}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
